<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 custom-title">QURAN HADEES LEARNING SCHOOL</h3>
        </div>
    </div>
    <div class="section pt-1" v-if="!loading_page">
        <div class="qhls-actions-grid">
            <router-link
                v-if="canShowRegisterCentreButton"
                :to="registerCentreLink"
                class="qhls-action-link"
            >
                <div class="qhls-action-card qhls-register-gradient">
                    <div class="qhls-action-content">
                        <div class="qhls-action-icon">
                            <ion-icon name="add-circle-outline"></ion-icon>
                        </div>
                        <span class="qhls-action-title mal-text">പുതിയ സെന്റർ രജിസ്റ്റർ ചെയ്യാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക</span>
                        <ion-icon name="chevron-forward-outline" class="qhls-action-arrow"></ion-icon>
                    </div>
                </div>
            </router-link>
            <router-link
                v-if="isWing2 && currentUser && currentUser.user_level == 3 && currentUser.zone_id"
                :to="`/org/3/${currentUser.zone_id}/qhls-exam-center`"
                class="qhls-action-link"
            >
            </router-link>
            <router-link
                v-if="canViewQhlsWeeklyReports"
                :to="weeklyReportLink"
                class="qhls-action-link"
            >
                <div class="qhls-action-card qhls-report-gradient">
                    <div class="qhls-action-content">
                        <div class="qhls-action-icon">
                            <ion-icon name="bar-chart-outline"></ion-icon>
                        </div>
                        <span class="qhls-action-title mal-text">{{ weeklyReportTitle }}</span>
                        <ion-icon name="chevron-forward-outline" class="qhls-action-arrow"></ion-icon>
                    </div>
                </div>
            </router-link>
            <router-link
                v-if="permissions.report && !canViewQhlsWeeklyReports && !viewingUnitLevel"
                :to="'/org/' + user_level + '/' + user_level_id + '/qhls-registrations'"
                class="qhls-action-link"
            >
                <div class="qhls-action-card qhls-list-gradient">
                    <div class="qhls-action-content">
                        <div class="qhls-action-icon">
                            <ion-icon name="list-outline"></ion-icon>
                        </div>
                        <span class="qhls-action-title mal-text">രജിസ്റ്റർ ചെയ്ത ലിസ്റ്റ് കാണാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക</span>
                        <ion-icon name="chevron-forward-outline" class="qhls-action-arrow"></ion-icon>
                    </div>
                </div>
            </router-link>
            <router-link
                v-if="canViewQhlsCentreCatalog"
                :to="'/org/' + user_level + '/' + user_level_id + '/qhls-pending-approval'"
                class="qhls-action-link"
            >
                <div class="qhls-action-card qhls-pending-gradient">
                    <div class="qhls-action-content">
                        <div class="qhls-action-icon">
                            <ion-icon name="time-outline"></ion-icon>
                        </div>
                        <span class="qhls-action-title">Request for Approval</span>
                        <ion-icon name="chevron-forward-outline" class="qhls-action-arrow"></ion-icon>
                    </div>
                </div>
            </router-link>
            <router-link
                v-if="canViewQhlsCentreCatalog"
                :to="'/org/' + user_level + '/' + user_level_id + '/qhls-affiliated-centers'"
                class="qhls-action-link"
            >
                <div class="qhls-action-card qhls-affiliated-gradient">
                    <div class="qhls-action-content">
                        <div class="qhls-action-icon">
                            <ion-icon name="checkmark-circle-outline"></ion-icon>
                        </div>
                        <span class="qhls-action-title">Affiliated Centers</span>
                        <ion-icon name="chevron-forward-outline" class="qhls-action-arrow"></ion-icon>
                    </div>
                </div>
            </router-link>
            <router-link
                v-if="canViewQhlsCentreCatalog"
                :to="'/org/' + user_level + '/' + user_level_id + '/qhls-faculty-listing'"
                class="qhls-action-link"
            >
                <div class="qhls-action-card qhls-faculty-gradient">
                    <div class="qhls-action-content">
                        <div class="qhls-action-icon">
                            <ion-icon name="people-outline"></ion-icon>
                        </div>
                        <span class="qhls-action-title">Faculty Listing</span>
                        <ion-icon name="chevron-forward-outline" class="qhls-action-arrow"></ion-icon>
                    </div>
                </div>
            </router-link>
        </div>
        <!-- <router-link :to="'/donations/qhls-fees'">
            <button type="button" class="btn btn-danger me-1 mal-text btn-lg col-12 mb-2 bg-white">
                ഫീസ് അടക്കാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക 
                        <ion-icon name="chevron-forward-outline" style="font-size: 60px;"></ion-icon>
                    </button>
        </router-link> -->
    </div>
    <div class="section pb-2 qhls-centers-section" v-if="showUnitCentersList && !loading_page">
        <div class="listed-detail mt-2 mb-2" v-if="centerList.length === 0">
            <h4 class="text-center text-muted mal-text">ഈ യൂണിറ്റിൽ ഇതുവരെ സെന്ററുകൾ ചേർത്തിട്ടില്ല</h4>
        </div>
        <div class="card pl-2 pr-2 mt-1 qhls-center-card" v-for="center in centerList" :key="center.id">
            <div class="listed-detail mt-1">
                <h3 class="text-center mt-1">{{ center.center_name }}</h3>
            </div>
            <ul class="listview flush transparent simple-listview no-space mt-1">
                <li>
                    <strong>Status</strong>
                    <span :class="center.approve_status == 'Pending Approval' ? 'text-warning' : 'text-success'">
                        {{ center.approve_status }}
                    </span>
                </li>
                <li v-if="center.reg_no || center.center_reg_no">
                    <strong>Reg No</strong>
                    <span class="text-success">{{ center.reg_no || center.center_reg_no }}</span>
                </li>
                <li>
                    <strong>Class Type</strong>
                    <span class="text-primary">{{ center.class_type || '-' }}</span>
                </li>
                <li>
                    <strong>Coordinator</strong>
                    <span class="text-primary">{{ getCoordinatorName(center) || '-' }}</span>
                </li>
                <li>
                    <strong>Faculty</strong>
                    <span class="text-primary" v-if="center.faculty">
                        {{ center.faculty.name }}<br>{{ center.faculty.mobile }}
                        <button
                            v-if="canShowFacultyActions(center)"
                            type="button"
                            class="btn btn-warning btn-sm me-1 mb-1"
                            @click="adminView(center)"
                        >
                            Edit
                        </button>
                    </span>
                    <span class="text-primary" v-else>
                        <button
                            v-if="canShowFacultyActions(center)"
                            type="button"
                            class="btn btn-primary btn-sm me-1 mb-1"
                            @click="adminView(center)"
                        >
                            Add
                        </button>
                        <span v-else class="text-danger">Not Added</span>
                    </span>
                </li>
                <li>
                    <strong>Added By</strong>
                    <span class="text-primary">{{ center.added_by_name }}</span>
                </li>
                <li v-if="editReqStatus[center.id]">
                    <strong>Edit Request</strong>
                    <span :class="editStatusClass(editReqStatus[center.id].status)">
                        {{ editStatusLabel(editReqStatus[center.id].status) }}
                        <template v-if="editReqStatus[center.id].by"> · {{ editReqStatus[center.id].by }}</template>
                    </span>
                </li>
                <li v-if="canRequestEditCenter(center) && (!editReqStatus[center.id] || editReqStatus[center.id].status !== 'pending')">
                    <strong>Action</strong>
                    <span>
                        <router-link
                            :to="`/org/${$route.params.sub_level}/${$route.params.id}/qhls-registration/${center.id}?editRequest=1`"
                            class="text-info"
                        >
                            Request Edit
                        </router-link>
                    </span>
                </li>
                <li v-if="canEditPendingCenter(center) || canDeletePendingCenter(center)">
                    <strong>Action</strong>
                    <span>
                        <router-link
                            v-if="canEditPendingCenter(center)"
                            :to="`/org/${$route.params.sub_level}/${$route.params.id}/qhls-registration/${center.id}`"
                            class="text-primary"
                        >
                            View / Edit
                        </router-link>
                        <template v-if="canEditPendingCenter(center) && canDeletePendingCenter(center)">
                            &nbsp;|&nbsp;
                        </template>
                        <a
                            v-if="canDeletePendingCenter(center)"
                            href="javascript:void(0)"
                            class="text-danger"
                            @click.prevent="deleteCenter(center)"
                        >
                            Delete
                        </a>
                    </span>
                </li>
                <li v-if="canOpenCentreDashboard(center)">
                    <strong></strong>
                    <span>
                        <router-link :to="'/org/qhls/' + center.id" class="text-primary">
                            <button type="button" class="btn btn-primary btn-sm btn-block">QHLS Dashboard</button>
                        </router-link>
                    </span>
                </li>
            </ul>
        </div>
    </div>
    <!-- AddAdminModel -->
    <div class="modal fade action-sheet" id="addAdminModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!add_admin">Edit</h5>
                    <h5 class="modal-title" v-if="add_admin">Add New</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addAdmin" :validation-schema="schema">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="stay"><span>നിലവിൽ മെമ്പർ ആണോ</span></label>
                                    <select as="select" class="form-control custom-select" v-model="isMember" name="isMember" id="select4">
                                                                                        <option value>---Select---</option>
                                                                                        <option value="Y">അതെ</option>
                                                                                        <option value="N">അല്ല</option>
                                                                                    </select>
                                </div>
                                <input type="hidden" v-model="member_id" />
                            </div>
                            <div class="form-group basic typehead-div" v-if="isMember == 'Y'">
                                <div class="input-wrapper">
                                    <label class="label" for="text4b">Member</label>
                                    <v-select label="text" :filterable="true" v-model="member" :value="member" :options="member_list" @input="getTextList($event.target.value, 'all')">
                                        <template>
                                                                                        type to search...
                                        </template>
                                        
                                        <template>
                                            <div class="d-center">
                                                {{ member.name }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <ErrorMessage name="member" class="error-feedback" />
                                </div>
                                <div class="input-info" v-if="member">Mobile :{{ member.country_code }} {{
                                        member.mobile
                                }}
                                </div>
                            </div>
                            <div class="form-group basic" v-if="isMember == 'N' || (edit_admin && isMember != 'Y')">
                                <div class="input-wrapper">
                                    <label class="label" for="name"><span>Name</span></label>
                                    <Field name="name" type="text" class="form-control" v-model="name" placeholder="Name" autocomplete="off" />
                                </div>
                                <ErrorMessage name="name" class="error-feedback" />
                            </div>
                            <div class="row" v-if="isMember == 'N' || (edit_admin && isMember != 'Y')">
                                <div class="col-5">
                                    <div class="form-group basic">
                                        <div class="input-wrapper">
                                            <label class="label" for="code">Code <span class="text-danger">*</span></label>
                                            <Field as="select" class="form-control custom-select" id="code" name="code"
                                                v-model="code">
                                                <option value="" :disabled="true" selected>#</option>
                                                <option v-for="code in country_code_list" v-bind:key="code.item_value"
                                                    v-bind:value="code.item_value">
                                                    {{ code.name }}</option>
                                            </Field>
                                        </div>
                                        <ErrorMessage name="code" class="error-feedback" />
                                    </div>
                                </div>
                                <div class="col-7">
                                    <div class="form-group basic">
                                        <div class="input-wrapper">
                                            <label class="label" for="mobile">Mobile <span
                                                    class="text-danger">*</span></label>
                                            <Field type="number" class="form-control" id="mobile" name="mobile"
                                                placeholder="Mobile" v-model="mobile"
                                                oninput="javascript: if (this.value.length > 10) this.value = this.value.slice(0, 10);" />
                                            <i class="clear-input">
                                                <ion-icon name="close-circle"></ion-icon>
                                            </i>
                                        </div>
                                        <ErrorMessage name="mobile" class="error-feedback" />
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="isMember == 'N' || (edit_admin && isMember != 'Y')">
                                <div class="col-5">
                                    <div class="form-group basic">
                                        <div class="input-wrapper">
                                            <label class="label" for="country_code_whatsapp">Code</label>
                                            <Field as="select" class="form-control custom-select" id="country_code_whatsapp" name="country_code_whatsapp"
                                                v-model="country_code_whatsapp" @change="onChangeCountryCode($event)">
                                                <option value="" :disabled="true" selected>#</option>
                                                <option v-for="code in country_code_list" v-bind:key="code.item_value"
                                                    v-bind:value="code.item_value">
                                                    {{ code.name }}</option>
                                            </Field>
                                        </div>
                                        <ErrorMessage name="code" class="error-feedback" />
                                    </div>
                                </div>
                                <div class="col-7">
                                    <div class="form-group basic">
                                        <div class="input-wrapper">
                                            <label class="label" for="whatsapp">Whatsapp </label>
                                            <Field type="number" class="form-control" id="whatsapp" name="whatsapp"
                                                placeholder="whatsapp" v-model="whatsapp"
                                                oninput="javascript: if (this.value.length > 10) this.value = this.value.slice(0, 10);" />
                                            <i class="clear-input">
                                                <ion-icon name="close-circle"></ion-icon>
                                            </i>
                                        </div>
                                        <ErrorMessage name="whatsapp" class="error-feedback" />
                                    </div>
                                </div>
                            </div>
    
                            <div class="form-group" v-if="message">
                                <div v-if="message" class="error-feedback">
                                    {{ message }}
                                </div>
                            </div>
    
                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading" v-if="update_faculty">
                                                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                                        <span>Save</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg" v-if="!update_faculty" @click="closeAddAdminModel">Close</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- DeleteMemberModel -->
    <div class="section text-center" v-if="loading_page">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params" ref="dialog_model"></dialog-model>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import $ from "jquery";
import UserService from "../../services/user.service";
import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";
import vSelect from 'vue-select'
export default {
    name: "Admin List",
    props: {
        unit_id: null
    },
    components: {
        Form,
        Field,
        vSelect,
        ErrorMessage,
        AlertModel,
        DialogModel,
    },
    data() {
        const schema = yup.object().shape({
        });
        return {
            loading: false,
            loading_page: false,
            user_level: "",
            editReqStatus: {},   // center_id -> { status, by }
            schema,
            member_lists: [],
            member_list: [],
            country_code_list: [],  
            member: [],
            isMember: '',
            name:'',
            code: '91',
            mobile: '',
            whatsapp: '',
            country_code_whatsapp: '91',
            user_level_id: "",
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            dialog_action_params: [],
            update_faculty:false,
            permissions: {
                edit: true,
                report: false,
                manage_centers: false,
            },
            responseData: {
                centers: [],
            },
            editable_id : '',
            editable_centre_id :'',
            add_admin: false,
            edit_admin: false,
            member_id: '',
            message: '',
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        centerList() {
            if (this.responseData && Array.isArray(this.responseData.centers)) {
                return this.responseData.centers;
            }
            return [];
        },
        canManageCenters() {
            if (!this.currentUser) return false;
            return String(this.currentUser.user_level) === '4'
                && String(this.$route.params.sub_level) === '4'
                && String(this.$route.params.id) === String(this.currentUser.unit_id);
        },
        canShowRegisterCentreButton() {
            if (!this.currentUser) return false;
            if (this.canManageCenters) return true;
            if (this.viewingUnitLevel) {
                const ul = parseInt(String(this.currentUser.user_level), 10);
                return ul >= 1 && ul <= 3;
            }
            return false;
        },
        registerCentreLink() {
            return `/org/${this.manageOrgSubLevel}/${this.manageOrgId}/qhls-registration`;
        },
        viewingUnitLevel() {
            return parseInt(String(this.$route.params.sub_level), 10) === 4;
        },
        showUnitCentersList() {
            return this.viewingUnitLevel;
        },
        weeklyReportLink() {
            return `/org/${this.user_level}/${this.user_level_id}/qhls-weekly-report`;
        },
        weeklyReportTitle() {
            return 'QHLS പ്രാദേശിക റിപ്പോർട്ട്';
        },
        manageOrgSubLevel() {
            if (this.viewingUnitLevel) return 4;
            if (!this.currentUser) return this.user_level;
            return this.canManageCenters && this.currentUser.unit_id ? 4 : this.user_level;
        },
        manageOrgId() {
            if (this.viewingUnitLevel) return parseInt(this.$route.params.id, 10);
            if (!this.currentUser) return this.user_level_id;
            return this.canManageCenters && this.currentUser.unit_id ? this.currentUser.unit_id : this.user_level_id;
        },
        isWing2() {
            const w = this.currentUser?.wing_id ?? this.currentUser?.wing ?? this.currentUser?.wing_type;
            const n = parseInt(String(w ?? ''), 10);
            return n === 2;
        },
        canViewQhlsWeeklyReports() {
            if (!this.currentUser) return false;
            const ul = parseInt(String(this.currentUser.user_level), 10);
            // Regional report only for state/district/zone admins, not on unit dashboard or for unit users.
            return ul >= 1 && ul <= 3 && !this.viewingUnitLevel;
        },
        isStateAdmin() {
            if (!this.currentUser) return false;
            return parseInt(String(this.currentUser.user_level), 10) === 1
                && parseInt(String(this.$route.params.sub_level || this.currentUser.user_level), 10) === 1;
        },
        isDistrictAdmin() {
            if (!this.currentUser) return false;
            return parseInt(String(this.currentUser.user_level), 10) === 2
                && parseInt(String(this.$route.params.sub_level || this.currentUser.user_level), 10) === 2;
        },
        isZoneAdmin() {
            if (!this.currentUser) return false;
            return parseInt(String(this.currentUser.user_level), 10) === 3
                && parseInt(String(this.$route.params.sub_level || this.currentUser.user_level), 10) === 3;
        },
        canViewQhlsCentreCatalog() {
            if (!this.currentUser || this.viewingUnitLevel) return false;
            if (this.isStateAdmin) return true;
            const routeId = parseInt(String(this.$route.params.id || 0), 10);
            if (this.isDistrictAdmin) {
                const districtId = parseInt(String(this.currentUser.district_id || 0), 10);
                return !districtId || !routeId || routeId === districtId;
            }
            if (this.isZoneAdmin) {
                const zoneId = parseInt(String(this.currentUser.zone_id || 0), 10);
                return !zoneId || !routeId || routeId === zoneId;
            }
            return false;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
        } else {
            this.$root.updateParent("QHLS");
            // Opened org context from URL
            this.user_level = parseInt(this.$route.params.sub_level || this.currentUser.user_level);
            this.user_level_id = parseInt(this.$route.params.id || 0);
            this.getComboboxValues('COUNTRY_CODE');
            if (this.viewingUnitLevel) {
                this.getCreCenterData(1);
                this.loadEditRequestStatuses();
            }
        }

        window.onpopstate = function() {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },
    watch: {
        '$route.params.id'() {
            this.user_level = parseInt(this.$route.params.sub_level || this.currentUser.user_level, 10);
            this.user_level_id = parseInt(this.$route.params.id || 0, 10);
            if (this.viewingUnitLevel) {
                this.getCreCenterData(1);
                this.loadEditRequestStatuses();
            } else {
                this.responseData = { centers: [] };
            }
        },
        '$route.params.sub_level'() {
            this.user_level = parseInt(this.$route.params.sub_level || this.currentUser.user_level, 10);
            this.user_level_id = parseInt(this.$route.params.id || 0, 10);
            if (this.viewingUnitLevel) {
                this.getCreCenterData(1);
                this.loadEditRequestStatuses();
            } else {
                this.responseData = { centers: [] };
            }
        },
    },
    methods: {
        // A managing level (unit/zone/district) can request an edit on an APPROVED centre.
        canRequestEditCenter(center) {
            if (!this.currentUser || !center) return false;
            if (String(center.approve_status) !== 'Approved') return false;
            if (!this.viewingUnitLevel) return false;
            if (String(center.user_level_id) !== String(this.$route.params.id)) return false;
            if (this.canManageCenter && this.canManageCenter(center)) return true;
            const ul = parseInt(String(this.currentUser.user_level), 10);
            return ul >= 1 && ul <= 5;
        },
        editStatusLabel(s) {
            return s === 'pending' ? 'Requested' : s === 'approved' ? 'Approved' : s === 'denied' ? 'Denied' : s;
        },
        editStatusClass(s) {
            return s === 'pending' ? 'text-warning' : s === 'approved' ? 'text-success' : 'text-danger';
        },
        loadEditRequestStatuses() {
            UserService.authPostRequest('get-cre-edit-requests', {}).then(
                (response) => {
                    if (response.data.status === 'success') {
                        const map = {};
                        (response.data.data.list || []).forEach((r) => {
                            if (map[r.center_id] === undefined) map[r.center_id] = { status: r.status, by: r.requested_by_name };
                        });
                        this.editReqStatus = map;
                    }
                },
                () => {}
            );
        },
        getCoordinatorName(center) {
            if (!center) return '';
            if (center.coordinator_name) return center.coordinator_name;

            const memberName = (value) => {
                if (!value) return '';
                if (typeof value === 'object' && value.name) return value.name;
                return '';
            };

            const org = center.coordinator_org_cordinator;
            const youth = center.coordinator_youth_cordinator;
            const women = center.coordinator_women_cordinator;
            const classType = center.class_type;

            if (classType === 'Ladies Only') {
                return memberName(women);
            }
            if (classType === 'Gents Only') {
                return memberName(org) || memberName(youth);
            }
            return memberName(org) || memberName(youth) || memberName(women);
        },
        canShowFacultyActions(center) {
            if (!center || this.permissions.qhls_convenor_readonly) return false;
            return !!(center.action_permission || this.permissions.edit);
        },
        canManageCenter(center) {
            if (!this.currentUser) return false;
            const ul = parseInt(String(this.currentUser.user_level), 10);
            if (ul !== 4) return false;
            if (parseInt(String(this.$route.params.sub_level), 10) !== 4) return false;
            if (String(this.$route.params.id) !== String(this.currentUser.unit_id)) return false;
            if (center && String(center.approve_status) === 'Approved') return false;
            return true;
        },
        canEditPendingCenter(center) {
            if (!this.currentUser || !center) return false;
            if (String(center.approve_status) !== 'Pending Approval') return false;
            if (!this.viewingUnitLevel) return false;
            if (String(center.user_level_id) !== String(this.$route.params.id)) return false;
            if (this.canManageCenter(center)) return true;
            if (this.permissions.manage_centers) return true;
            const ul = parseInt(String(this.currentUser.user_level), 10);
            return ul >= 1 && ul <= 3;
        },
        canDeletePendingCenter(center) {
            // Same users who can View/Edit a pending centre (unit admin, creator, regional admins on unit page).
            return this.canEditPendingCenter(center);
        },
        canOpenCentreDashboard(center) {
            if (!this.currentUser || !center) return false;
            if (!this.viewingUnitLevel) return false;
            if (String(center.user_level) !== '4') return false;
            if (String(center.user_level_id) !== String(this.$route.params.id)) return false;

            // Pending centres: only unit admin can open dashboard (to add faculty/students before approval).
            if (String(center.approve_status) === 'Pending Approval') {
                return this.canManageCenter(center);
            }

            const ul = parseInt(String(this.currentUser.user_level), 10);
            if (ul >= 1 && ul <= 3) return true;

            return String(this.currentUser.user_level) === '4'
                && String(this.currentUser.unit_id) === String(this.$route.params.id);
        },
        getCreCenterData(id) {
            this.loading_page = true;
            const data = {
                id: id,
                type: 'QHLS',
                view_level: parseInt(this.$route.params.sub_level || this.currentUser.user_level, 10),
                view_level_id: parseInt(this.$route.params.id || 0, 10),
            };
            UserService.authPostRequest('get-my-centers', data).then(
                (response) => {
                    this.loading_page = false;
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data || { centers: [] };
                        if (!Array.isArray(this.responseData.centers)) {
                            this.responseData.centers = [];
                        }
                        this.permissions = {
                            ...this.permissions,
                            ...(response.data.data.permissions || {}),
                        };
                    } else {
                        this.responseData = { centers: [] };
                    }
                },
                (error) => {
                    this.loading_page = false;
                    this.responseData = { centers: [] };
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        deleteCenter(center) {
            if (!center || !center.id) return;
            if (!this.canDeletePendingCenter(center)) return;
            this.dialog_action_params = { id: center.id, type: 'QHLS' };
            this.dialog_message = "ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?";
            this.dialog_action = "confirmDeleteCenter";
            this.$refs.dialog_model.openModel();
        },
        confirmDeleteCenter(params) {
            UserService.authPostRequest('delete-cre-center', params).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getCreCenterData(1);
                    } else {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.alert_type = 'Error';
                    this.alert_message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        getTextList(event, type) {
            this.message = '';
            let data = {
                q: event,
                type: type,
                filter: 'inside',
                user_level: 1
            }
            UserService.authPostRequest('get-typehead-values', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_list = response.data.data.list;
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id,
            };
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case "COUNTRY_CODE":
                            this.country_code_list = response.data.data.list.options;
                            break;
                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminView(center) {
            this.member = [];
            this.isMember = '';
            $('#addAdminModel').modal('show');
            this.message = '';
            this.editable_centre_id = center.id;
            if(center.faculty){
                if (center.faculty.member_id) {
                    this.isMember = 'Y';
                    this.member_id = center.faculty.member_id;
                    this.disable_member_form = true;
                    this.member = {
                        id: center.faculty.member_id,
                        member_id: center.faculty.member_id,
                        text: center.faculty.name,
                        mobile: center.faculty.mobile,
                        country_code: center.faculty.country_code
                    }
                    this.member_list.push(this.member);
                } else {
                    this.isMember = 'N';
                    this.disable_member_form = false;
                    this.name = center.faculty.name;
                    this.code = center.faculty.country_code;
                    this.mobile = center.faculty.mobile;
                    this.whatsapp = center.faculty.whatsapp;
                    this.country_code_whatsapp = center.faculty.country_code_whatsapp;
                }
                this.editable_id = center.faculty.id;
            }
            
            if(center.action_permission){
                this.update_faculty = true;
            }
        },
        closeAddAdminModel() {
            $('#addAdminModel').modal('hide');
        },
        addAdmin(user) {
            this.loading = true;
            user.editable_id = this.editable_id;
            user.editable_centre_id = this.editable_centre_id;
            user.is_member = this.isMember;
            if (this.isMember == 'Y') {
                if (this.member) {
                    if (this.member.length == 0) {
                        this.alert_type = 'Warning';
                        this.alert_message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്തതിനു ശേഷം Save അമർത്തുക.';
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                        return false;
                    }
                } else {
                    this.alert_type = 'Warning';
                    this.alert_message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്തതിനു ശേഷം Save അമർത്തുക.';
                    this.$refs.alert_model.openModel();
                    this.loading = false;
                    return false;
                }

            }
            if (this.isMember == 'N' && !user.name) {
                this.alert_type = 'Warning';
                this.alert_message = 'ദയവായി പേര് ഫിൽ ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                this.loading = false;
                return false;
            }
            if (this.isMember == 'N' && !user.mobile) {
                this.alert_type = 'Warning';
                this.alert_message = 'ദയവായി മൊബൈൽ ഫിൽ ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                this.loading = false;
                return false;
            }
            if (this.isMember == 'Y') {
                user.member_id = this.member.id;
            } else {
                user.member_id = null;
            }
            UserService.addAdmin('store-qhls-faculty', user).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addAdminModel').modal('hide')
                        this.getCreCenterData(1);
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                        this.message = '';
                        this.editable_centre_id = '';
                        this.editable_id = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
    }
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.green-tick {
    font-size: 18px;
    color: darkgreen;
}

.red-cross {
    font-size: 18px;
    color: red;
}

.qhls-text {
    font-style: italic;
    color: #266bd1;
}

.qhls-actions-grid {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0 2px;
}

.qhls-action-link {
    text-decoration: none;
    display: block;
    width: 100%;
}

.qhls-action-card {
    width: 100%;
    border-radius: 12px;
    padding: 14px 16px;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;
}

.qhls-action-card:active {
    transform: scale(0.98);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
}

.qhls-action-content {
    display: flex;
    align-items: center;
    gap: 14px;
}

.qhls-action-icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.22);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.qhls-action-icon ion-icon {
    font-size: 22px;
    color: #ffffff;
}

.qhls-action-title {
    flex: 1;
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    line-height: 1.4;
    text-align: left;
}

.qhls-action-arrow {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.85);
    flex-shrink: 0;
}

.qhls-register-gradient {
    background: linear-gradient(135deg, #1a418c 0%, #3f51b5 100%);
}

.qhls-list-gradient {
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}

.qhls-pending-gradient {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.qhls-affiliated-gradient {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.qhls-report-gradient {
    background: linear-gradient(135deg, #64748b 0%, #475569 100%);
}

.qhls-faculty-gradient {
    background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);
}

.qhls-centers-section {
    padding-top: 4px;
}

.qhls-center-card {
    border: 1px solid #e8eef5;
    border-radius: 10px;
}

.custom-file-upload {
    position: relative;
    display: flex;
    width: 50%;
    height: 100px;
}

.form-check-input:disabled~.form-check-label,
.form-check-input[disabled]~.form-check-label {
    opacity: 1;
}

.form-check-input:disabled~.form-check-label,
.form-check-input[disabled]~.form-check-label {
    color: #060606;
}
</style>
